import React from 'react';
import { TriangleSlider } from '../../slider';
import { AppSkinProps } from '../../../types/decisions';
import { useLocation } from 'react-router-dom';
import NameWithIcon from './NameWithIcon/NameWithIcon';
import CustomSettingsTitle from './CustomSelectFields/CustomSettingsTitle';
import './AppCriteriaFields.scss';

const AppCriteriaFields = ({
    criteriaData,
    onSliderChange,
    onChangeCommitted,
    hideTitle = false,
}: AppSkinProps & {
    hideTitle?: boolean;
    onChangeCommitted?: () => void;
}) => {
    const location = useLocation();
    const isDisabled = location.pathname.startsWith('/patient-choice');

    return (
        <div className={hideTitle ? '' : 'app-criteria-card-wrapper'}>
            {!hideTitle && (
                <CustomSettingsTitle
                    title="What Matters Most"
                    description="Slide the bars to set the importance of the criteria"
                />
            )}
            <br/>
            {criteriaData.fields.map(({
                id,
                name,
                hide_importance,
                link,
                icon,
            }, idx) => (
                <div
                    key={id}
                    className={`app-criteria-field ${hide_importance ? 'hidden' : ''}`}
                >
                    <label>
                        <NameWithIcon
                            icon={icon}
                            name={typeof name === 'string' ? name : name?.value || ''}
                            link={link}
                        />
                        <TriangleSlider
                            name={id}
                            min={0}
                            max={100}
                            step={1}
                            value={+criteriaData.fields[idx].importance}
                            onChange={(_, value) => onSliderChange(value as number, id)}
                            onChangeCommitted={onChangeCommitted}
                            disabled={isDisabled}
                        />
                    </label>
                </div>
            ))}
        </div>
    );
};

export default AppCriteriaFields;